import axios from 'axios';
import { MDBCol, MDBContainer, MDBRipple, MDBRow,MDBAlert,MDBBtn } from "mdb-react-ui-kit";

import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchCart } from '../utils/Common';
import { CartContext } from '../context/CartProvider';
import { CategoryContext } from '../context/CategoryContext';
import { UserProfileContext } from '../context/UserProfileProvider';
import { GeographyContext } from '../context/GeographyProvider';
const Products = () => {
  const {ipAddress} = useContext(GeographyContext);
  const {tokenLoaded} = useContext(UserProfileContext);
  const {selectCategories,categoryImages} = useContext(CategoryContext)
const{  cartId, setCartCount, setCartId} = useContext(CartContext);


  useEffect(() => {
    fetchCart(cartId, setCartCount, setCartId, tokenLoaded,ipAddress);
 
  }, []);

  return (
    
    <MDBContainer className='d-flex flex-column align-items-center justify-content-center '>
    <MDBRow className='justify-content-center'>
      <MDBCol>
        <MDBRow className='g-3 mt-2'>
          {selectCategories?.length === 1 ? (
            // Render the single category directly
            <MDBCol key={selectCategories[0].value} xs='12' sm='6' md='4' lg='3'>
              <div className='d-inline-flex position-relative'>
                <Link className="sidenav-link" to={`/shop/${selectCategories[0].text}`}>
                  <MDBRipple rippleTag='a'>
                    {categoryImages[selectCategories[0].text] ? (
                      <>
                        <img
                          src={categoryImages[selectCategories[0].text] && categoryImages[selectCategories[0].text].replace('_thumbnail', '')}
                          className='img-fluid rounded shadow-2-strong'
                          alt={selectCategories[0].text}
                        />
                        <div className="position-absolute bottom-0 start-50 translate-middle-x p-2">
                          <h2 className='text-primary text-capitalize fw-bold small-card'>{selectCategories[0].text}</h2>
                        </div>
                      </>
                    ) : (
                      <div className="p-2">
                        <h2 className='text-primary text-capitalize fw-bold small-card'>{selectCategories[0].text}</h2>
                      </div>
                    )}
                  </MDBRipple>
                </Link>
              </div>
            </MDBCol>
          ) : (
            // Render multiple categories
            selectCategories?.map((category, index) => (
              <MDBCol key={category.value} xs='12' sm='6' md='4' lg='3'>
                <div className='d-inline-flex position-relative'>
                  <Link className="sidenav-link" to={`/shop/${category.text}`}>
                    <MDBRipple rippleTag='a'>
                      {categoryImages[selectCategories[index].text] ? (
                        <>
                          <img
                            src={categoryImages[selectCategories[index].text] && categoryImages[selectCategories[index].text].replace('_thumbnail', '')}
                            className='img-fluid rounded shadow-2-strong'
                            alt={selectCategories[index].text}
                          />
                          <div className="position-absolute bottom-0 start-50 translate-middle-x p-2">
                            <h1 className='text-light text-capitalize fw-bold '>{selectCategories[index].text}</h1>
                          </div>
                        </>
                      ) : (
                        <div className="p-2">
                          <h2 className='text-black text-capitalize fw-bold small-card'>{selectCategories[index].text}</h2>
                        </div>
                      )}
                    </MDBRipple>
                  </Link>
                </div>
              </MDBCol>
            ))
          )}
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
  

  );
};


export default Products;
